import React from "react";

import ReqActionBar from "../common/ReqActionBar";
import PoliticalDetail from "./PoliticalDetail";


const PoliticalDetailComp = (props)=>{

    return(
        <div className="panel">
            <div className="panel-header">
                <div className="panel-header-label">Political Contribution Request Details</div>
                {props.data.createdTimeStampUserTz && <div>Created : {props.data.createdTimeStampUserTz}</div>}
                {props.data.lastAction !== "Pending" && <div className="ml-4">{props.data.lastAction} : {props.data.updatedTimeStampUserTz}</div>}
            </div>

            <PoliticalDetail data={props.data} mode="DETAIL"/>

            <ReqActionBar
                reqId={props.data.id}
                reqType="POLITICAL"
                reqStatus={props.data.status}
                reloadItem={props.reloadItem}
                handleUpdate={props.handleUpdate}
                handleClose={props.handleClose}
            />
            

        </div>
    );
};


export default PoliticalDetailComp;